import React, { useRef, useState } from 'react'
import { useOnClickOutside } from './hooks'

function SecureButton({
  children,
  confirm,
  confirmClassName,
  className,
  onConfirm,
  ...props
}) {
  const ref = useRef()
  const [isConfirm, setConfirm] = useState(false)
  useOnClickOutside(ref, () => setConfirm(false))
  function handleConfirm() {
    onConfirm()
    setConfirm(false)
  }
  return isConfirm ? (
    <button
      ref={ref}
      onClick={handleConfirm}
      className={confirmClassName}
      {...props}
    >
      {confirm}
    </button>
  ) : (
    <button
      onClick={(e) => {
        e.preventDefault()
        setConfirm(true)
      }}
      className={className}
      {...props}
    >
      {children}
    </button>
  )
}

export default SecureButton
